module.exports = __webpack_public_path__ + "static/media/homo_sapiens.female.52fda97c.svg";